export default {
  id: 'projects',
  title: 'Projects',
  category: 'Admin',
  summary: 'Organize work under contracts with funding, charge codes, employee assignments, and ATP — including cost-plus obligation funding on prime projects.',
  overview: 'Projects sit under contracts and are the operational home for charge codes and employee assignments. The Project Details page chooses a view based on project type: prime (T&M-style funding lines), prime cost-plus (Obligation Funding panel), or subcontract. Closing a project prevents further charging while preserving history.',
  howItWorks: [
    'Each project belongs to a contract (and therefore a customer).',
    'Prime T&M / non–cost-based projects use classic funding lines you can add, reorder, and tie to ATP and charge codes.',
    'Prime cost-plus projects use the Obligation Funding panel: Customer Funding Lines come from Contract Funding obligations; Labor and Fee line items consume that funding.',
    'Subcontract projects use a subcontract-oriented detail view for the sub agreement structure.',
    'Charge codes under a project are what employees select on timesheets; employee assignments control who can charge.',
    'Documents and ATP controls support authorization to proceed where enabled.'
  ],
  actions: [
    {
      name: 'Create project',
      description: 'Adds a project under a selected contract. Cost-based contracts produce cost-plus project funding behavior when applicable.'
    },
    {
      name: 'Manage classic funding lines',
      description: 'On non–cost-plus primes, add, reorder, or update funding allocations used for tracking and ATP.'
    },
    {
      name: 'Use Obligation Funding panel',
      description: 'On cost-plus primes, review Customer Funding Lines, manage breakout/attribution, add Labor + Fee pairs, and balance hours. See Funding Obligations help for details.'
    },
    {
      name: 'Manage charge codes / employees',
      description: 'Controls what can be charged and who is authorized to charge it.'
    },
    {
      name: 'Close / open / delete project',
      description: 'Close stops new activity; reopen restores it. Delete removes the project when allowed by system rules.'
    }
  ],
  tips: [
    'For cost-plus projects, add Contract Funding obligations on the contract before expecting Customer Funding Lines on the project.',
    'Assign employees and create charge codes before expecting timesheet entries.',
    'Unfunded or misaligned charge codes on classic projects can block clean ATP — keep funding and codes in sync.'
  ],
  related: ['contracts', 'funding-obligations', 'charge-codes', 'employees', 'invoices']
};



// WEBPACK FOOTER //
// ./client/help/content/projects.js